import Api from '@/api';


const updateLegacyCustomer = (context, data) => new Promise((resolve, reject) => {
  Api.LeadsService.patchCustomerLeads(data.customerLegacyId, data.body)
    .then(response => {
      context.commit('setLegacyCustomer', response);
      resolve(response);
    })
    .catch(() => {
      context.commit('setLegacyCustomer', {});
      reject();
    });
});

export default {
  updateLegacyCustomer,
};
